import styled from 'styled-components'
import { Column } from 'components/common/layout'
import { MediumText } from 'components/common/text'

export const SteveIconAndQuestionWrapper = styled(Column)`
  align-items: center;
  gap: 8px;
`

export const QuestionOptionWrapper = styled(Column)`
  align-items: center;
  gap: 60px;
  width: 100%;
  max-width: 500px;
  @media ${(p) => p.theme.deviceSize.mobile} {
    gap: 40px;
  }
`

export const FullWidthChipContainer = styled(Column)<{ width: number }>`
  gap: 8px;
  width: ${(p) => p.width}px;
  max-width: ${(p) => p.width}px;
  @media ${(p) => p.theme.deviceSize.mobile} {
    width: calc(100vw - 40px);
  }
`

export const OptionExplainText = styled(MediumText)`
  padding: 9px 12px;
  background-color: #eeeee9;
  border-radius: 12px;
  color: #9d9d99;
  font-size: ${(p) => p.theme.fontSize.desc};
  line-height: 24px;
  text-align: center;
  @media ${(p) => p.theme.deviceSize.mobile} {
    padding: 4px 12px;
    font-size: ${(p) => p.theme.fontSize.small};
  }
`
